import { alpha, paperClasses } from '@mui/material'

import { createConfiguratorTheme } from '@salsita-ai/platform-project-sdk/ui'

export const theme = createConfiguratorTheme({
  typography: {
    fontFamily: ['Poppins', 'sans-serif'].join(','),
    h4: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.3,
    },
    body2: {
      lineHeight: 1.25,
      fontWeight: 400,
      letterSpacing: '0.17px',
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 400,
      letterSpacing: '0.1px',
    },
  },
  palette: {
    primary: {
      main: '#000',
      light: '#333',
    },
    secondary: {
      main: '#C89415',
    },
    background: {
      scene: '#EDE9E6',
    },
    info: {
      main: '#E1F1FF',
    },
    error: {
      main: '#FE8A7E',
    },
    warning: {
      main: '#FEEBD6',
    },
    success: {
      main: '#EAF6CF',
    },
    action: {
      selected: alpha('#000', 0.04),
      selectedOpacity: 0.04,
    },
  },
  shape: {
    sidebarBorderRadius: 0,
  },
  components: {
    PhxPoweredBy: {
      defaultProps: {
        visible: false,
      },
    },
    PhxSidebarPanel: {
      styleOverrides: {
        padding: ({ theme }) => ({
          padding: theme.spacing(2.5),
          // is this supposed to be a token?
          backgroundColor: '#FCFCFC',
        }),
        footer: ({ theme }) => ({
          '& button': {
            backgroundColor: '#C89415',
            color: theme.palette.common.white,
            fontWeight: 300,
          },
          '& div': {
            gridTemplateColumns: '2fr 3fr !important',
          },
          '& div>div': {
            alignSelf: 'center',
          },
        }),
      },
    },
    PhxPropertyContainerItem: {
      styleOverrides: {
        content: ({ theme }) => ({
          marginTop: theme.spacing(2),
        }),
      },
    },
    PhxChat: {
      styleOverrides: {
        root: () => ({
          // is this supposed to be a token? -- see phx sidebar
          backgroundColor: '#FCFCFC',
        }),
      },
    },
    PhxChatMessage: {
      styleOverrides: {
        user: ({ theme }) => ({
          backgroundColor: theme.palette.secondary.main,
        }),
        assistant: ({ theme }) => ({
          // this needs a correct token
          backgroundColor: theme.palette.background.scene,
        }),
      },
    },
    PhxChatFooter: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === 'mobile' && {
            marginTop: 0,
          }),
        }),
        formLayout: () => ({
          borderRadius: 0,
        }),
      },
    },
    PhxDisabledOverlay: {
      defaultProps: {
        icon: 'Lock',
        placement: 'center',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: () => ({
          borderRadius: 0,
        }),
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
      defaultProps: {
        elevation: 0,
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: ({ theme }) => ({
          [`& .${paperClasses.root}`]: {
            borderRadius: theme.spacing(theme.shape.sidebarBorderRadius),
            border: 'none',
            boxShadow: theme.shadows[0],
          },
        }),
      },
    },
    MuiFab: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.spacing(0),
          boxShadow: theme.shadows[0],
        }),
      },
    },
  },
})
